import { createActionConst } from '../../../utils/action.utils';

const INVOICES_PAGE_NAMESPACE = 'INVOICES_PAGE';

export const FETCH_INVOICES = createActionConst(INVOICES_PAGE_NAMESPACE, 'FETCH_INVOICES');
export const STORE_INVOICES_LIST = createActionConst(INVOICES_PAGE_NAMESPACE, 'STORE_INVOICES_LIST');
export const CLEAR_INVOICES_PAGE = createActionConst(INVOICES_PAGE_NAMESPACE, 'CLEAR_INVOICES_PAGE');

export const FETCH_INVOICE_DETAIL = createActionConst(INVOICES_PAGE_NAMESPACE, 'FETCH_INVOICE_DETAIL');
